import config from "../../config.json";
import { useState } from "react";
import styled from "styled-components";
import { AnimatePresence } from "framer-motion";
import { theme } from "../../styles";
import { Title, Swapper, Modal } from "../../components";
import { ClientLinkWrapper, ClientGrid, ClientImage } from "./style";

const ClientLink = ({
  state,
  image,
  name,
  children,
  handleModal,
  animateDelay = theme.delayMd,
}) => (
  <ClientLinkWrapper
    state={state}
    initial={theme.fadeIn.initial}
    animate={theme.fadeIn.animate}
    transition={theme.fadeIn.transition(animateDelay)}
    onClick={() => handleModal()}
  >
    <Swapper height="8rem" swapChildren={name}>
      {children}
    </Swapper>
    <ClientImage image={image} />
  </ClientLinkWrapper>
);

const ClientLinks = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedClientInd, setSelectedClientInd] = useState(0);
  return (
    <>
      <AnimatePresence>
        <Modal
          key={modalOpen}
          open={modalOpen}
          handleCancel={(accept) => {
            setModalOpen(false);
          }}
          cancel='Return'
        >
          <ModalWrapper>
            {selectedClient && (
              <>
                <Title>{selectedClient}</Title>
                <ClientGallery>
                  {[...Array(config.clients[selectedClientInd].count)].map(
                    (_, ind) => {
                      return (
                        <ClientArt
                          src={require(`../../assets/clients/${selectedClient}/${
                            ind + 1
                          }.png`)}
                        />
                      );
                    }
                  )}
                </ClientGallery>
              </>
            )}
          </ModalWrapper>
        </Modal>
      </AnimatePresence>
      <ClientGrid>
        {config.clients.map((item, ind) => (
          <ClientLink
            key={`client-item-${ind}`}
            image={require(`../../assets/clients/${item.name}/profile.png`)}
            name={item.name}
            handleModal={() => {
              setModalOpen(true);
              setSelectedClient(item.name);
              setSelectedClientInd(ind);
            }}
          />
        ))}
      </ClientGrid>
    </>
  );
};

export default ClientLinks;

const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${(props) => props.theme.spaceLg};
`;

const ClientGallery = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spaceMd};
  align-items: center;
`;

const ClientArt = styled.img`
  width: 100%:
  height: auto;
  object-fit: cover;
  border-radius: ${(props) => props.theme.borderRadiusSm};
`;
